<script setup>
import { ref, provide, onMounted } from "vue";
import NavBar from "@/components/NavBar.vue";
import IntroSection from "@/components/IntroSection.vue";
import FooterBar from "@/components/FooterBar.vue";
import HowToPlay from "@/components/HowToPlay.vue";
import QuestionSection from "@/components/QuestionSection.vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const isMenuOpen = ref(false);

const toggleMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
}

provide('isMenuOpen', isMenuOpen);
provide('toggleMenu', toggleMenu);

onMounted(() => {
  document.title = t('meta.title') + ' | Just Eat';
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
  }
  metaDescription.content = t('meta.description');

  let canonicalLink = document.querySelector('link[rel="canonical"]');
  if (!canonicalLink) {
    canonicalLink = document.createElement('link');
    canonicalLink.rel = 'canonical';
    document.head.appendChild(canonicalLink);
  }
  canonicalLink.href = window.location.href;

});

</script>

<template>
    <NavBar />
    <IntroSection/>
    <HowToPlay />
    <QuestionSection />
    <FooterBar />
</template>


<style>
@font-face {
  font-family: JETSansVF2;
  src: url("assets/fonts/JETSansVF2-Merged.woff2") format("woff2"),
    url("assets/fonts/JETSansVF2-Merged.woff") format("woff");
  font-display: swap;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

p {
  font-family: "JETSansVF2", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  color: #242E30;
  text-wrap: pretty;
}

h1{
  font-family: "JETSansVF2", sans-serif;
  color: #242E30;
  text-wrap: pretty;
}

h2 {
  font-family: "JETSansVF2", sans-serif;
  font-size: 25px;
  font-weight: 800;
  line-height: 19px;
  color: #242E30;
  text-wrap: pretty;
}

h3{
  font-family: "JETSansVF2", Arial, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.04em;
  color: #242E30;
  text-wrap: pretty;
}


</style>
